import * as $ from 'jquery'
import {renderModal, Dimension} from '../../legacy/modal'

export type EventDefinerParams = {
		existingGoalUsers: string,
		newGoalUsers: string,
		goalUsersCount: number,
		contentsHtml: string,
		formId: string
	}

export class EventDefiner {
	private existingGoalUsers: string
	private newGoalUsers: string
	private formId: string
	private goalUsersCount: number
	private callback:(n:Node) => void
	private contentsHtml: string

	constructor (callback:(n:Node) => void, params:EventDefinerParams) {
		this.callback          = callback
		this.existingGoalUsers = params.existingGoalUsers
		this.newGoalUsers      = params.newGoalUsers
		this.goalUsersCount    = params.goalUsersCount
		this.contentsHtml      = params.contentsHtml
		this.formId            = params.formId
	}

	define() {
		$("[name=saveSubmit]").click(() => {this.onSaveGoal('saveSubmit'); return false})
		$("[name=saveReturnSubmit]").click(() => {this.onSaveGoal('saveReturnSubmit'); return false})
	}

	private onApplyChanges() {
		const basedOnRg0 = $('#applyChangesTypeRadioGroup_0').prop('checked') ? this.newGoalUsers : -1
		const basedOnBoth = $('#applyChangesTypeRadioGroup_1').prop('checked') ? this.existingGoalUsers : basedOnRg0
		$('#applyTo').val(basedOnBoth)
		;(<HTMLFormElement>document.getElementById(this.formId)).submit()
	}

	private modal() {
		return renderModal(
			'applyChangestypeModal',
			'Save Goal',
			this.contentsHtml,
			new Dimension(550, 350),
			this.callback,
			() => this.onApplyChanges()
		)
	}

	private onSaveGoal(mode:string) {
		if (mode === 'saveSubmit')
			(<HTMLInputElement>document.getElementById('saveSubmit')).value = '1'
		else if (mode === 'saveReturnSubmit')
			(<HTMLInputElement>document.getElementById('saveReturnSubmit')).value = '1'

		if (this.goalUsersCount > 0) {
			this.modal().dialog('open')
		} else {
			;(<HTMLInputElement>document.getElementById('applyTo')).value = this.existingGoalUsers
			;(<HTMLFormElement>document.getElementById(this.formId)).submit()
		}
	}
}



// WEBPACK FOOTER //
// ./src/compliancetracker/self-assignable goals/admin.ts